import { METHOD_TYPES } from 'utils/constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const getBlackJackGameBetHistory = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'blackjack-game/get-bets', {}, {
    server: microServices.SERVICE_URL_1,
    params
  })
}

export const blackJackGamePlaceBet = ({ data, isDemoGame }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/blackjack-game/place-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const blackJackGameHitBet = ({ data }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/blackjack-game/hit', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const blackJackGameStandBet = ({ data }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/blackjack-game/stand', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const blackJackGameDoubleBet = ({ data }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/blackjack-game/place-double-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const blackJackGameSplitBet = ({ data, isDemoGame }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/blackjack-game/place-split-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const blackJackUnfinishedBet = () => {
  return axiosInstanceService(METHOD_TYPES.get, 'fast-games/blackjack-game/get-unfinished-bet', {}, {
    server: microServices.SERVICE_URL_1
  })
}

export const blackJackPlaceInsuranceBet = ({ data }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/blackjack-game/place-insurance-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const blackJackUpdateCurrentHandStatus = ({ data }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/blackjack-game/update-current-hand-status', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const blackJackCheckFairness = ({ data }) => {
  return axiosInstanceService(METHOD_TYPES.post, 'fast-games/blackjack-game/check-fairness', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const getMyBlackJackTransactionsService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'fast-games/blackjack-game/get-my-bets', {}, {
    server: microServices.SERVICE_URL_1,
    params
  })
}

export const getBlackJackHighRollerTransactionsService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'fast-games/blackjack-game/top-bets', {}, {
    server: microServices.SERVICE_URL_1,
    params
  })
}

export const getBlackJackTransactionsService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, 'fast-games/blackjack-game/all-bets', {}, {
    server: microServices.SERVICE_URL_1,
    params
  })
}
